export const FETCH_FAQ_REQUEST = 'FETCH_FAQ_REQUEST'
export const FETCH_FAQ_SUCCESS = 'FETCH_FAQ_SUCCESS'
export const FETCH_FAQ_ERROR = 'FETCH_FAQ_ERROR'